import createSpeechSynthesisPonyfill from './TextToSpeech/createSpeechSynthesisPonyfill';

export default createSpeechSynthesisPonyfill
